import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.wearingPartCategories;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const wearingPartCategoriesSelector = createSelector(
    selectFeature, 
    (state) => state.wearingPartCategories
);